<template>
  <resource-create-wrapper
    :title="item ? $t('resources.categories.duplicate_page_category') : $t('resources.categories.new_page_category')"
    :need-modal="showModal"
    @saveAction="$refs['pageCategoryForm'].submit()">
    <PageCategoryForm :page-category="item" @isDirtyForm="isDirtyForm" ref="pageCategoryForm"></PageCategoryForm>
  </resource-create-wrapper>
</template>

<script>
  import ResourceCreateWrapper from "@/components/resourceWrappers/ResourceCreateWrapper";
  import PageCategoryForm from "@/components/forms/PageCategoryForm";
  import resourceCreateAndEditActions from "@/mixins/resourceCreateAndEditActions";

  export default {
    components: {
      ResourceCreateWrapper,
      PageCategoryForm,
    },
    mixins: [resourceCreateAndEditActions],
    props: {
      item: {
        type: Object,
        required: false,
        default() {
          return {};
        },
      },
    },
  };
</script>
